import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import {
    selectLastProvisionDate,
    selectOTTLastConnectionTime,
} from 'store/user/selectors';

import {
    BACKEND_INFORMATION_LAST_CONNECTION_TO_OTT,
    BACKEND_INFORMATION_LAST_PROVISION_DATE,
} from '../languagesConst';
import { BackendInfoLineup } from '../types';

function useBackendInfoLineups() {
    const ottLastConnectionTime = useSelector(selectOTTLastConnectionTime);
    const lastProvisionDate = useSelector(selectLastProvisionDate);

    const backendInfoLineups = useMemo<BackendInfoLineup[]>(() => {
        return [
            {
                id: BACKEND_INFORMATION_LAST_PROVISION_DATE,
                title: BACKEND_INFORMATION_LAST_PROVISION_DATE,
                rightTxt: lastProvisionDate,
            },
            {
                id: BACKEND_INFORMATION_LAST_CONNECTION_TO_OTT,
                title: BACKEND_INFORMATION_LAST_CONNECTION_TO_OTT,
                rightTxt: ottLastConnectionTime,
            },
        ];
    }, []);

    return { backendInfoLineups };
}

export default useBackendInfoLineups;
